export const AUTH_SCREEN = {
  SIGNUP: "signup",
  LOGIN: "login",
} as const;

export const AUTH_TYPE = {
  AUTH: "auth",
  FORGOT_PASSWORD: "forgotPassword",
} as const;

export const POST_SIGNUP_URL = "https://aftershoot.com/post-signup/";

export const PHOTON_URL = "https://getphoton.com";
export const PHOTON_DOWNLOAD_URL = `${PHOTON_URL}/downloads/`;

// Photon funnel routes. Attribution only; each keeps its own post-auth redirect.
export const PHOTON_AUTH_PATHS = [
  "/photon-login",
  "/photon-login/",
  "/next-login",
  "/next-login/",
];

export const PHOTON_LOGIN_PATHS = ["/photon-login", "/photon-login/"];

export const SIGNUP_SOURCE = {
  AFTERSHOOT: "aftershoot",
  PHOTON: "photon",
  MASTIN: "mastin",
} as const;

export type TSignupSource = (typeof SIGNUP_SOURCE)[keyof typeof SIGNUP_SOURCE];

export const MASTIN_AUTH_PATHS = ["/signup-mastin", "/signup-mastin/"];
export const MASTIN_REF_CODES = ["mastin90"];

export const PHOTON_APP_ROUTES = [
  "/photon-login",
  "/photon-login/",
  "/next-login",
  "/next-login/",
  "/open-photon",
  "/open-photon/",
];

export const isPhotonAppRoute = (pathname: string) =>
  PHOTON_APP_ROUTES.includes(pathname);

export const PHOTON_SUPPORT_EMAIL = "photonsupport@aftershoot.com";

/**
 * Partner codes that carry their own post-signup destination, keyed by the
 * `ref` query param the marketing site forwards to /auth, e.g.
 * aftershoot.com/friends/?ref=lensel -> /auth?...&ref=lensel&signup=true.
 * Values are keys of EXTERNAL_REDIRECT_MAP.
 */
export const REF_REDIRECT_KEY_MAP: Record<string, string> = {
  lensel: "referral-thank-you",
  mastin90: "mastin90-thank-you",
};

export const EXTERNAL_REDIRECT_MAP: Record<string, string> = {
  "mastin-thank-you":
    "https://mastinlabs.com/pages/mastin-x-aftershoot-thank-you",
  "referral-thank-you": "https://aftershoot.com/thank-you-referral/",
  "mastin90-thank-you": "https://aftershoot.com/thank-you-mastinxaftershoot/",
  "post-signup": POST_SIGNUP_URL,
};

export const AUTH_VARIANT = {
  CONTROL: "control",
  V2: "signup-v2",
} as const;

export const DEFAULT_AUTH_VARIANT = AUTH_VARIANT.CONTROL;

export const AUTH_VARIANT_QUERY_PARAM = "auth_variant";

export const AUTH_VARIANT_PERSON_PROP = "signup_page_variant";

export const PHOTON_AUTH_EVENT_PROPS = {
  page: "auth",
  product: "photon",
} as const;

export const AUTH_NOTICE = {
  BLACK_FRIDAY: "black-friday",
} as const;

// `/auth?email=<email>&coupon=<code>` toasts the notice mapped to that coupon
export const AUTH_COUPON_NOTICE: Record<
  string,
  (typeof AUTH_NOTICE)[keyof typeof AUTH_NOTICE]
> = {
  blackfriday26: AUTH_NOTICE.BLACK_FRIDAY,
};
